// Analytics Sidebar Component
// Navigation sidebar for analytics pages (white theme)

import { Link } from 'react-router-dom';
import { 
  MessageSquare, 
  LayoutDashboard, 
  Settings, 
  FileCode, 
  LogOut,
  BarChart3,
  Palette,
  Bell,
  HelpCircle,
  FileSpreadsheet
} from 'lucide-react';

const AnalyticsSidebar = ({ logout, activePath = '/analytics' }) => {
  const navItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
    { icon: BarChart3, label: 'Analytics', path: '/analytics' },
    { icon: Palette, label: 'Branding', path: '/branding' },
    { icon: FileSpreadsheet, label: 'CMS Integration', path: '/cms-integrations' },
    { icon: Bell, label: 'Notifications', path: '/notifications' },
    { icon: FileCode, label: 'Embed Code', path: '/embed' },
    { icon: Settings, label: 'Settings', path: '/settings' },
    { icon: HelpCircle, label: 'Help Center', path: '/help' }
  ];

  return (
    <aside className="w-64 bg-white border-r border-slate-200 flex flex-col" data-testid="analytics-sidebar">
      <div className="p-6 border-b border-slate-200">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-10 h-10 bg-teal-500 rounded-xl flex items-center justify-center">
            <MessageSquare className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
            IntakePal
          </span>
        </Link>
      </div>
      
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => {
          const isActive = activePath === item.path;
          return (
            <Link 
              key={item.path}
              to={item.path} 
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive 
                  ? 'bg-teal-50 text-teal-700 font-medium' 
                  : 'text-slate-600 hover:bg-slate-50'
              }`}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <item.icon className="w-5 h-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
      
      <div className="p-4 border-t border-slate-200">
        <button 
          onClick={logout}
          className="flex items-center gap-3 px-4 py-3 text-slate-600 hover:bg-slate-50 rounded-lg transition-colors w-full"
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default AnalyticsSidebar;
